module.exports = __webpack_public_path__ + "img/nz.cf117b0.svg";